import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

function parsePermissions(value) {
  if (!value || typeof value !== 'string') return {};
  try {
    const p = JSON.parse(value);
    return p && typeof p === 'object' ? p : {};
  } catch {
    return {};
  }
}

export async function fetchShareholderUsers() {
  const res = await fetch(`${API_BASE}/api/shareholder/users`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المستخدمين'));
  const list = Array.isArray(data) ? data : [];
  return list.map((u) => ({
    id: u.id,
    userName: u.userName,
    fullName: u.fullName ?? '',
    email: u.email ?? '',
    phone: u.phone ?? '',
    isActive: !!u.isActive,
    permissionsJson: u.shareholderPermissionsJson ?? '{}',
    permissions: parsePermissions(u.shareholderPermissionsJson),
  }));
}

export async function createShareholderUser(payload) {
  const res = await fetch(`${API_BASE}/api/shareholder/users`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إضافة المستخدم'));
  return data;
}

export async function updateShareholderUser(userId, payload) {
  const res = await fetch(`${API_BASE}/api/shareholder/users/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحديث المستخدم'));
  return {
    id: data.id,
    userName: data.userName,
    fullName: data.fullName ?? '',
    email: data.email ?? '',
    phone: data.phone ?? '',
    isActive: !!data.isActive,
    permissionsJson: data.shareholderPermissionsJson ?? '{}',
    permissions: parsePermissions(data.shareholderPermissionsJson),
  };
}

export async function updateShareholderUserPermissions(userId, permissions) {
  const res = await fetch(`${API_BASE}/api/shareholder/users/${encodeURIComponent(userId)}/permissions`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify({ shareholderPermissionsJson: JSON.stringify(permissions ?? {}) }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ الصلاحيات'));
  return data;
}
